(function () {
  "use strict";

  var configCache = null;
  var popupInitialized = false;
  var lastPdpPopupKind = "unchecked";

  function getTracking() {
    return window.CrownPassTracking || null;
  }

  function resolvePdpPopupKind(config) {
    var state = resolvePopupState(config);
    if (state === "member") return "purchase_member";
    if (state === "active") return "checked";
    return "unchecked";
  }

  function isConfigMember(config) {
    return !!(config && config.user_status === "member");
  }

  function getCore() {
    return window.CrownPassCore || null;
  }

  function getPdpContext(productId) {
    var map = window.__CROWN_PASS_PDP__ || {};
    return map[productId] || map[String(productId)] || null;
  }

  function resolvePopupState(config) {
    var Core = getCore();
    if (Core && typeof Core.resolvePopupState === "function") {
      return Core.resolvePopupState(config);
    }
    if (config && config.user_status === "member") {
      return "member";
    }
    return "purchase";
  }

  function loadConfig(ctx) {
    var Core = getCore();
    if (!Core) {
      return Promise.reject(new Error("CrownPassCore is not loaded"));
    }
    return Core.loadConfig(ctx).then(function (config) {
      configCache = config;
      return config;
    });
  }

  function shouldShowBanner(config, ctx) {
    var Core = getCore();
    if (Core && typeof Core.shouldShowPdpModule === "function") {
      return Core.shouldShowPdpModule(config, ctx);
    }
    return !!(config && config.enabled);
  }

  function getWrapper($banner) {
    var $wrapper = $banner.closest(".Product__Wrapper");
    if ($wrapper.length) {
      return $wrapper;
    }

    var productId = $banner.data("product-id");
    if (productId) {
      $wrapper = window.jQuery("#" + productId).closest(".Product__Wrapper");
      if ($wrapper.length) {
        return $wrapper;
      }
    }

    return window.jQuery(".Product__Wrapper").first();
  }

  function parseMoneyTextToCents(text) {
    if (!text) return 0;
    var normalized = String(text)
      .replace(/[^\d.,]/g, "")
      .replace(/,/g, "");
    var value = parseFloat(normalized);
    if (isNaN(value)) return 0;
    return Math.round(value * 100);
  }

  function readCentsFromEl($el) {
    if (!$el || !$el.length) return 0;

    if (
      window.KlaiyiUtils &&
      typeof KlaiyiUtils.getCentsFromEl === "function"
    ) {
      var utilsCents = KlaiyiUtils.getCentsFromEl($el);
      if (utilsCents > 0) {
        return utilsCents;
      }
    }

    var attrCents = $el.attr("data-cents");
    if (attrCents != null && attrCents !== "" && !isNaN(attrCents)) {
      var parsedAttr = Number(attrCents);
      if (parsedAttr > 0) {
        return parsedAttr;
      }
    }

    var dataCents = $el.data("cents");
    if (dataCents != null && !isNaN(dataCents) && Number(dataCents) > 0) {
      return Number(dataCents);
    }

    var $money = $el.find(".money").first();
    if ($money.length) {
      var moneyCents = readCentsFromEl($money);
      if (moneyCents > 0) {
        return moneyCents;
      }
    }

    return parseMoneyTextToCents($el.text());
  }

  function getPriceScope($wrapper) {
    return $wrapper.find(".ProductMeta__PriceList, .ProductMeta").first();
  }

  function getCurrentPriceCents($wrapper) {
    var $scope = getPriceScope($wrapper);
    var $price = $scope.find(".Price--highlight").first();
    return readCentsFromEl($price);
  }

  function getVisibleBuyoutPriceCents($wrapper) {
    var $scope = getPriceScope($wrapper);
    var $buyout = $scope.find(".buyout_out").first();
    if (!$buyout.length || $buyout.hasClass("none") || !$buyout.is(":visible")) {
      return 0;
    }

    var cents = readCentsFromEl($buyout.find(".buyout_price").first());
    if (cents > 0) {
      return cents;
    }

    return readCentsFromEl($buyout.find(".buyout_price .money").first());
  }

  function calculateAfterCodePriceCents($wrapper, currentPriceCents) {
    var visibleBuyoutCents = getVisibleBuyoutPriceCents($wrapper);
    if (visibleBuyoutCents > 0) {
      return visibleBuyoutCents;
    }

    var discountValue =
      parseFloat($wrapper.find(".product_xinzheng_discount").first().text()) || 0;
    var discountType = $wrapper.find(".discount_type").first().text().trim();

    if (discountType === "1" && discountValue > 0) {
      return Math.ceil(currentPriceCents * (1 - discountValue / 100));
    }
    if (discountType === "2" && discountValue > 0) {
      return Math.max(currentPriceCents - Math.round(discountValue * 100), 0);
    }

    return 0;
  }

  function getSavingBase($wrapper) {
    var currentPriceCents = getCurrentPriceCents($wrapper);
    var afterCodePriceCents = calculateAfterCodePriceCents(
      $wrapper,
      currentPriceCents
    );

    if (afterCodePriceCents > 0) {
      return {
        cents: afterCodePriceCents,
        useCodeRate: true,
      };
    }

    return {
      cents: currentPriceCents,
      useCodeRate: false,
    };
  }

  function getDiscountRate(config, ctx, useCodeRate) {
    var Core = getCore();
    if (Core && typeof Core.getDiscountRate === "function") {
      return Core.getDiscountRate(config, ctx, useCodeRate);
    }
    return 0.07;
  }

  function formatSavingAmount(cents) {
    cents = Math.max(Number(cents) || 0, 0);

    if (window.KlaiyiUtils && typeof KlaiyiUtils.setPriceEl === "function") {
      var $temp = window.jQuery('<span class="money"></span>');
      KlaiyiUtils.setPriceEl($temp, cents);
      var formatted = $temp.text().trim();
      if (formatted) {
        return formatted;
      }
    }

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(
        cents,
        (window.theme && window.theme.moneyFormat) || "${{amount}}"
      );
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function applyCopyTemplate(template, amountText, membershipName) {
    var membership = membershipName || "Crown Pass";
    var text = String(template || "Save Extra {amount} With {membership_name}");

    if (/\{amount\}/.test(text)) {
      return text
        .replace(/\{amount\}/g, amountText)
        .replace(/\{membership_name\}/g, membership);
    }

    if (/\$[\d,.]+/.test(text)) {
      return text
        .replace(/\$[\d,.]+/, amountText)
        .replace(/\{membership_name\}/g, membership);
    }

    return "Save Extra " + amountText + " With " + membership;
  }

  function resolveUserStatus(config) {
    return config.user_status || "guest";
  }

  function resolveCopy(config) {
    var status = resolveUserStatus(config);
    var copyMap = config.copy || {};
    return copyMap[status] || copyMap.guest || copyMap.non_member || {};
  }

  function syncContainerVisibility($banner) {
    var $container = $banner.closest(".falsh-sale-con");
    if (!$container.length) return;

    var hasVisibleChild = $container.children(":visible").length > 0;
    if (hasVisibleChild) {
      $container.removeAttr("hidden").show();
    } else if ($container.hasClass("falsh-sale-con--crown-pass-only")) {
      $container.attr("hidden", "hidden").hide();
    }
  }

  function calculateBannerSavingCents(savingBaseCents, config, ctx, useCodeRate) {
    var Core = getCore();
    if (Core && typeof Core.calculateSavingCents === "function") {
      return Core.calculateSavingCents(
        savingBaseCents,
        config,
        ctx,
        useCodeRate
      );
    }
    var rate = getDiscountRate(config, ctx, useCodeRate);
    return Math.round(Math.max(Number(savingBaseCents) || 0, 0) * rate);
  }

  function updateBannerSaving($banner, config, ctx) {
    var $wrapper = getWrapper($banner);
    if (!$wrapper.length) return;

    var savingBase = getSavingBase($wrapper);
    var savingCents = calculateBannerSavingCents(
      savingBase.cents,
      config,
      ctx,
      savingBase.useCodeRate
    );
    var amountText = formatSavingAmount(savingCents);
    var membershipName = config.membership_name || "Crown Pass";
    var copy = resolveCopy(config);

    $banner.find("[data-crown-pass-title]").text(
      applyCopyTemplate(copy.title, amountText, membershipName)
    );

    var $action = $banner.find("[data-crown-pass-action]");
    if (copy.button_text) {
      $action.text(copy.button_text).removeAttr("hidden");
    } else {
      $action.attr("hidden", "hidden");
    }

    $banner.data("crown-pass-saving-text", amountText);
  }

  function getPopupSavingText($banner) {
    var cached = $banner.data("crown-pass-saving-text");
    if (cached) return cached;

    var $wrapper = getWrapper($banner);
    if (!$wrapper.length || !configCache) return "$0.00";

    var savingBase = getSavingBase($wrapper);
    var ctx = getPdpContext($banner.data("product-id")) || {};
    return formatSavingAmount(
      calculateBannerSavingCents(
        savingBase.cents,
        configCache,
        ctx,
        savingBase.useCodeRate
      )
    );
  }

  function formatPopupBenefitHtml(text, index) {
    if (!text) return "";

    if (index === 2) {
      return (
        '<span class="crown-pass-popup__benefit-single">' + text + "</span>"
      );
    }

    var match = text.match(/^(Extra\s+)(\d+%)(\s+Off)\s+(.+)\.?$/i);
    if (!match) {
      return (
        '<span class="crown-pass-popup__benefit-single">' + text + "</span>"
      );
    }

    var mainHtml =
      match[1] +
      '<span class="crown-pass-popup__benefit-percent">' +
      match[2] +
      "</span>" +
      match[3];
    var subText = match[4].replace(/\.$/, "");

    return (
      '<span class="crown-pass-popup__benefit-main">' +
      mainHtml +
      "</span>" +
      '<span class="crown-pass-popup__benefit-sub">' +
      subText +
      "</span>"
    );
  }

  function updatePopupContent(config, amountText) {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var popupConfig = (config && config.popup) || {};
    var $popup = $("[data-crown-pass-popup]");
    if (!$popup.length) return;

    var titleTemplate =
      popupConfig.title || "Save Extra {amount} Today!";
    $popup.find("[data-crown-pass-popup-title]").html(
      applyCopyTemplate(
        titleTemplate,
        '<span class="crown-pass-popup__amount">' + amountText + "</span>",
        config.membership_name
      )
    );

    if (popupConfig.ribbon_text) {
      $popup.find(".crown-pass-popup__ribbon-text").text(popupConfig.ribbon_text);
    }

    var benefits = popupConfig.benefits || [];
    var benefitSelectors = [
      "[data-crown-pass-benefit-first]",
      "[data-crown-pass-benefit-later]",
      "[data-crown-pass-benefit-stack]",
    ];
    benefitSelectors.forEach(function (selector, index) {
      if (benefits[index]) {
        $popup
          .find(selector)
          .html(formatPopupBenefitHtml(benefits[index], index));
      }
    });

    if (popupConfig.purchase_button_text) {
      $popup
        .find("[data-crown-pass-purchase]")
        .text(popupConfig.purchase_button_text);
    }
    if (popupConfig.active_button_text) {
      $popup.find("[data-crown-pass-use]").text(popupConfig.active_button_text);
    }
    if (popupConfig.cancel_text) {
      $popup.find("[data-crown-pass-cancel]").text(popupConfig.cancel_text);
    }
    var Core = getCore();
    var validityText =
      (Core && Core.getMembershipValidityText(config, popupConfig)) ||
      popupConfig.validity_text;
    if (validityText) {
      $popup.find("[data-crown-pass-validity]").text(validityText);
    }
  }

  function setPopupState(state) {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var $popup = $("[data-crown-pass-popup]");
    if (!$popup.length) return;

    var $purchase = $popup.find("[data-crown-pass-purchase]");
    var $activeGroup = $popup.find("[data-crown-pass-active-group]");
    var $validity = $popup.find("[data-crown-pass-validity]");

    $purchase.attr("hidden", "hidden");
    $activeGroup.attr("hidden", "hidden");
    $validity.attr("hidden", "hidden");

    if (state === "member") {
      $validity.removeAttr("hidden");
      return;
    }

    if (state === "active") {
      $activeGroup.removeAttr("hidden");
      return;
    }

    $purchase.removeAttr("hidden");
  }

  function syncPopupFooterForConfig(config, $banner) {
    if (!window.jQuery || !config) return;
    var $ = window.jQuery;
    var $targetBanner = $banner && $banner.length ? $banner : $("[data-crown-pass-banner]").first();
    var amountText = $targetBanner.length
      ? getPopupSavingText($targetBanner)
      : "$0.00";
    updatePopupContent(config, amountText);
    var Core = getCore();
    if (Core && typeof Core.resolvePopupState === "function") {
      setPopupState(Core.resolvePopupState(config));
      lastPdpPopupKind = resolvePdpPopupKind(config);
    }
  }

  function openCrownPassPopup($banner, config) {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var $popup = $("[data-crown-pass-popup]");
    if (!$popup.length) return;

    syncPopupFooterForConfig(config, $banner);
    var tracking = getTracking();
    if (tracking) {
      tracking.trackPdpMemberRightsPopupView(lastPdpPopupKind);
    }
    $popup.addClass("is-open").attr("aria-hidden", "false").removeAttr("hidden");
    document.body.classList.add("crown-pass-popup-open");
  }

  function closeCrownPassPopup(options) {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var $popup = $("[data-crown-pass-popup]");
    if (!$popup.length) return;

    var skipCloseTrack = options && options.skipCloseTrack;
    var tracking = getTracking();
    if (tracking && !skipCloseTrack && $popup.hasClass("is-open")) {
      tracking.trackPdpMemberRightsPopupClick(lastPdpPopupKind, "close");
    }
    $popup.removeClass("is-open").attr("aria-hidden", "true").attr("hidden", "hidden");
    document.body.classList.remove("crown-pass-popup-open");
  }

  function initCrownPassPopup(config) {
    if (popupInitialized || !window.jQuery) return;
    popupInitialized = true;

    var $ = window.jQuery;
    var $popup = $("[data-crown-pass-popup]");
    if (!$popup.length) return;

    function trackPdpBannerOpen($banner) {
      if (!configCache) return;
      var tracking = getTracking();
      if (!tracking) return;
      var isMember = isConfigMember(configCache);
      var buttonText =
        $banner.find("[data-crown-pass-action]").text().trim() ||
        $banner.find("[data-crown-pass-title]").text().trim();
      tracking.trackPdpBannerClick(isMember, buttonText);
    }

    $(document).on("click", "[data-crown-pass-banner]", function (event) {
      var $banner = $(this);
      if ($banner.hasClass("is-hidden") || !configCache) return;
      event.preventDefault();
      trackPdpBannerOpen($banner);
      openCrownPassPopup($banner, configCache);
    });

    $(document).on("keydown", "[data-crown-pass-banner]", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var $banner = $(this);
      if ($banner.hasClass("is-hidden") || !configCache) return;
      event.preventDefault();
      trackPdpBannerOpen($banner);
      openCrownPassPopup($banner, configCache);
    });

    $popup.on("click", "[data-crown-pass-close]", function () {
      closeCrownPassPopup();
    });

    function activatePdpCrownPassSelection() {
      var Core = getCore();
      if (!Core) return;
      Core.setDefaultSelectedDismissed(false);
      Core.setPdpCartSelected(true);
      Core.setMockMembershipStatus("active");
      Core.persistPdpSelectionToShopifyCart().catch(function (err) {
        console.warn("[CrownPass] persist cart selection failed:", err);
      });
      setPopupState("active");
      lastPdpPopupKind = "checked";
    }

    $popup.on("click", "[data-crown-pass-purchase]", function () {
      var tracking = getTracking();
      if (tracking) {
        tracking.trackPdpMemberRightsPopupClick(
          "unchecked",
          $(this).text().trim()
        );
      }
      activatePdpCrownPassSelection();
    });

    $popup.on("click", "[data-crown-pass-cancel]", function () {
      var tracking = getTracking();
      if (tracking) {
        tracking.trackPdpMemberRightsPopupClick("checked", "cancel");
      }
      var Core = getCore();
      if (Core) {
        Core.setMockMembershipStatus("none");
        Core.setDefaultSelectedDismissed(true);
        Core.setPdpCartSelected(false);
        var deselectPromise =
          typeof Core.deselectCrownPassOnShopifyCart === "function" &&
          configCache
            ? Core.deselectCrownPassOnShopifyCart(configCache)
            : Core.clearPdpSelectionFromShopifyCart();
        deselectPromise.catch(function () {
          /* ignore */
        });
      }
      setPopupState("purchase");
      lastPdpPopupKind = "unchecked";
    });

    $popup.on("click", "[data-crown-pass-use]", function () {
      var tracking = getTracking();
      if (tracking) {
        tracking.trackPdpMemberRightsPopupClick("checked", $(this).text().trim());
      }
      activatePdpCrownPassSelection();
      closeCrownPassPopup({ skipCloseTrack: true });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeCrownPassPopup();
      }
    });
  }

  function showBanner($banner) {
    $banner
      .removeClass("is-hidden")
      .attr("aria-hidden", "false")
      .attr("tabindex", "0");
    syncContainerVisibility($banner);
  }

  function hideBanner($banner) {
    $banner
      .addClass("is-hidden")
      .attr("aria-hidden", "true")
      .attr("tabindex", "-1");
    syncContainerVisibility($banner);
  }

  function initBanner($banner, config, ctx) {
    if (!shouldShowBanner(config, ctx)) {
      hideBanner($banner);
      return;
    }

    showBanner($banner);
    updateBannerSaving($banner, config, ctx);

    var tracking = getTracking();
    if (tracking) {
      var bannerEl = $banner.get(0);
      var viewKey =
        "pdp-crown-pass-" +
        String($banner.data("product-id") || "") +
        (isConfigMember(config) ? "-member" : "-guest");
      tracking.observeViewOnce(bannerEl, viewKey, function () {
        tracking.trackPdpBannerView(isConfigMember(config));
      });
    }
  }

  function updateAllBanners() {
    if (!window.jQuery) return;
    var $ = window.jQuery;

    $("[data-crown-pass-banner]").each(function () {
      var $banner = $(this);
      var productId = $banner.data("product-id");
      var ctx = getPdpContext(productId);
      if (!ctx || !configCache) return;
      if ($banner.hasClass("is-hidden")) return;
      updateBannerSaving($banner, configCache, ctx);
    });
  }

  function scheduleBannerRefresh() {
    updateAllBanners();
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(updateAllBanners);
    }
    setTimeout(updateAllBanners, 120);
  }

  function bootstrap() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var $banners = $("[data-crown-pass-banner]");
    if (!$banners.length) return;

    var firstBanner = $banners.first();
    var productId = firstBanner.data("product-id");
    var ctx = getPdpContext(productId);
    if (!ctx) return;

    loadConfig(ctx)
      .then(function (config) {
        configCache = config;
        var Core = getCore();
        if (Core && typeof Core.applyPdpDefaultSelected === "function") {
          return Core.applyPdpDefaultSelected(config, ctx).then(function () {
            return config;
          });
        }
        return config;
      })
      .then(function (config) {
        initCrownPassPopup(config);
        $banners.each(function () {
          var $banner = $(this);
          var bannerCtx = getPdpContext($banner.data("product-id")) || ctx;
          initBanner($banner, config, bannerCtx);
        });
        syncPopupFooterForConfig(config, $banners.first());
        scheduleBannerRefresh();
      });
  }

  function hookPriceUpdates() {
    if (
      window.KlaiyiUtils &&
      typeof KlaiyiUtils.updateBuyoutPriceInfo === "function" &&
      !KlaiyiUtils.updateBuyoutPriceInfo.__crownPassHooked
    ) {
      var original = KlaiyiUtils.updateBuyoutPriceInfo;
      KlaiyiUtils.updateBuyoutPriceInfo = function (container) {
        var result = original.apply(this, arguments);
        scheduleBannerRefresh();
        return result;
      };
      KlaiyiUtils.updateBuyoutPriceInfo.__crownPassHooked = true;
    }

    document.addEventListener("variant:changed", function () {
      scheduleBannerRefresh();
    });
  }

  if (typeof onKlaiyiJQuery === "function") {
    onKlaiyiJQuery(function () {
      hookPriceUpdates();
      bootstrap();
    });
  } else if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      hookPriceUpdates();
      bootstrap();
    });
  } else {
    hookPriceUpdates();
    bootstrap();
  }
})();
